module.exports = [{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/.pnpm/gatsby@5.13.3_patch_hash=2a570fd1984fae97a95cb12efcc80df19163b98bb476ace7d4552ce1e8e9fc_4a32c608311384f10d177e43b2fa3545/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
